// Initialize the cart
$(document).ready(async function () {
  $('.total-price').addClass('hidden');
  await initPartnerChefsSample();
  await verifyDiscount();
  await scrollMobile();
  await loadMeals();
  await loadBreakfast();
  await loadWraps(); 
  await constructionFromActiveCards();
  await changeDiscountDisplay();
  await CalculateCartTotal();
  await CartDrawerAPI.changeAtcButtonText();
});
const key = "quiz_responses_v2";
// go to checkout
$(document).on("click", ".go-to-checkout", async function (e) {
  const $btn = $(this);
  $btn.prop('disabled', true).text('processing...');
  await window.FormEvents.clearCart();
  await window.FormEvents.clearCartAttributes();
  e.preventDefault();
  const storage = localStorage.getItem(key);
  const quizComplete = storage ? JSON.parse(storage).winner : null;
  const getDiscountCode = quizComplete ? 'INTRO_80' : "null";
  await window.CartDrawerAPI.initCart(getDiscountCode);
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
      event: 'go_to_checkout_button_click',
      source: "chefs-sample"
  });
  return (window.location.href = "/checkout");
});

//função para fazer scroll até a seção das meals
function initPartnerChefsSample() {
  const pageHandle = sessionStorage.getItem('page_handle') ?? '';
  if(pageHandle == "meal-plan-offer") return;
  const el = document.getElementById('section-products');
  if (el) {
    const offset = -90;
    const y =
        el.getBoundingClientRect().top +
        window.pageYOffset +
        offset;

    window.scrollTo({
        top: y,
        behavior: 'smooth'
    });
  }
}

function formatTimestampToDate(timestamp) {
  const date = new Date(Number(timestamp));
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
}

function verifyDiscount() {
  $('#discount-form').hide();
  const storage = localStorage.getItem(key);
  const quizComplete = storage ? JSON.parse(storage).winner : null;
  const discount = quizComplete ? 'INTRO_80' : "null";
  if(discount=="null") return; 
  fetch(`/discount/${discount}`).then(()=> {
      fetch('/cart?view=discount', {}).then(function(res){return res.text();})
      .then(async function(data) {
          let dataObject = JSON.parse(JSON.stringify(data));
          dataObject = JSON.parse(dataObject);
          const appliedCodes = dataObject.discounts.map(i => i.title.trim().toLowerCase());
          if (!appliedCodes.includes(discount.trim().toLowerCase())) {
              $('.discount-code-message').text(`Your discount code ${discount} will be applied at checkout.`);
          }
      })
  });
}

function scrollMobile() {
    if ($(window).width() > 768)return;
    const $section = $("#section-products");
    const $sectionCart = $(".section-products__cart");
    const offset = 300;
    $sectionCart.hide();
    $(window).on("scroll", function () {
        const sectionTop = $section.offset().top; 
        const scrollTop = $(window).scrollTop();

        if (scrollTop >= sectionTop - offset) {
            $sectionCart.fadeIn();
             $('.chat-icon').css('bottom', '19%');
        } else {
            $sectionCart.fadeOut();
             $('.chat-icon').css('bottom', '5%');
        }
    });
}

// discount form
$(document).on("submit", "#discount-form", async function (e) {
  e.preventDefault();
  const $form = $(this);
  const code = $form.find('input[name="discount"]').val().trim();
  fetch(`/discount/${code}`).then(() => {
    fetch("/cart?view=discount", {})
      .then(function (res) {
        return res.text();
      })
      .then(async function (data) {
        let dataObject = JSON.parse(JSON.stringify(data));
        dataObject = JSON.parse(dataObject);
        const appliedCodes = dataObject.discounts.map((i) =>
          i.title.trim().toLowerCase()
        );
        if (appliedCodes.includes(code.trim().toLowerCase())) {
          $(".discount-info").text(`Discount code applied: ${code}`);
          $(".discount-info").removeClass("hidden");
          await window.CartDrawerAPI.buildCart();
        } else {
          $(".discount-info").text(`${code} is not a valid discount code.`);
          $(".discount-info").removeClass("hidden");
        }
      });
  });
});

// funcao para calcular o total do carrinho
function CalculateCartTotal() {
  let total = 0;
  let totalUpsell = 0;
  $(".section-products__plan .product-card").each(function () {
    const price = parseFloat($(this).data("product-price") || 16);
    const quantity = 1;
    total += price * quantity;
  });

  
  $(".cart-item").each(function () {
    const priceUpsell = parseFloat($(this).data("price") || 16);
    const quantity = $(this).data("quantity") || 1;
    totalUpsell += priceUpsell * quantity;
  });
  
  const storage = localStorage.getItem(key);
  const quizComplete = storage ? JSON.parse(storage).winner : null;
  const discount = quizComplete ? 0 : 0;// se existir desconto, colocar o valor aqui
  const totalPrice = ((total * 0.95) - discount + (totalUpsell / 100));

  const integerPart = totalPrice.toFixed(2).split('.')[0];
  const decimalPart = totalPrice.toFixed(2).split('.')[1] || '00';
  const integerCompare = total.toFixed(2).split('.')[0]; 
  const decimalCompare = total.toFixed(2).split('.')[1] || '00';
  
  $('.total-price').addClass('hidden');
  $('.total-price-decimal').addClass('hidden');


  $('.total-price-omt').removeClass('hidden');
  $('.total-price-omt-decimal').removeClass('hidden');

  $('.compare-price').text(`$${integerCompare}.`);
  $('.compare-price-decimal').text(decimalCompare);
  
  $('.total-price-omt').text(`$${integerPart}.`);
  $('.total-price-omt-decimal').text(decimalPart);
}
const href = new URL(window.location.href);
const segments = href.pathname.split('/').filter(Boolean);
const plan = segments[segments.length - 1].replace('-chefs-sample','');

// funcao principal para popular os produtos
async function loadMeals() {
  const parser = new DOMParser();
  let url = window.Shopify.routes.root + `products/${plan}-one-month-trial?view=one-week`;
  let htmldoc = await $.get(url);
  let htmlDoc = parser.parseFromString(htmldoc, 'text/html');
  const itemList = htmlDoc.querySelector('#product-list-container');
  $('.section-products__plan').empty().append(itemList);
}
async function loadWraps() {
  const parser = new DOMParser();
  let htmldoc = await $.get('/collections/wraps?view=render-products&filter.v.availability=1');
  htmlDoc = parser.parseFromString(htmldoc, 'text/html');
  const itemList = htmlDoc.querySelector('#product-list');
  $('.section-products__wraps').empty().append(itemList);
}

async function loadBreakfast() {
  const parser = new DOMParser();
  let htmldoc = await $.get('/collections/breakfast?view=render-products&filter.v.availability=1');
  htmlDoc = parser.parseFromString(htmldoc, 'text/html');
  const itemList = htmlDoc.querySelector('#product-list');
  $('.section-products__breakfast').empty().append(itemList);
}

$(document).on("submit", 'form[action*="/cart/add"]', async function (e) {
  e.preventDefault();
  const $form = $(this);
  try {
    const data = formToObject($form);
    await FormEvents.addItem(data);
    await constructorUpsell();
    await CartDrawerAPI.changeAtcButtonText();
    await CalculateCartTotal();
  } catch (err) {
    console.error("Erro ao adicionar item ao carrinho:", err);
  }
});

$(document).on('click', '.cart-item-remove', async function (e) {
    const $item = $(this).closest('.cart-item');
    const itemKey = $item.data('key');
    await FormEvents.updateQuantityItem(itemKey, 0);
    await constructorUpsell();
    await CartDrawerAPI.changeAtcButtonText();
    await CalculateCartTotal();
});

const loading = {
    template: `<div class="loading-overlay__spinner">
      <svg  aria-hidden="true"  focusable="false"  class="w-6 h-5 animate-rotator"  viewBox="0 0 66 66"  xmlns="http://www.w3.org/2000/svg">
        <circle class="animate-dash path stroke-gray-500" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
      </svg>
    </div>`
}

$(document).on('click', '.cart-accordion-header', async function (e) {
    const $this = $(this).closest('.cart-accordion');
    $this.toggleClass('hide-content');
});

$(document).on('click', '#product-form-minus, #product-form-plus', async function (e) {
    e.preventDefault();
    const $formId = $(this).closest('form').data('productid');
    const $cartId = $(`.cart-item[data-product-id="${$formId}"]`);
    const $itemKey = $cartId.data('key');
    const $quantityElement = $cartId.find('.quantity-input');
    const $formQuantity = $(this).closest('form').find('#product-form-quantity');
    let quantity = parseInt($quantityElement.val(), 10);
    if ($(this).hasClass('minus-btn-quantity')) {
        if (quantity <= 1) {
            quantity = 0;
        } else {
            quantity -= 1;
        }
    } else if ($(this).hasClass('plus-btn-quantity')) {
        quantity += 1;
    }
    
    try {
        $formQuantity.empty().html(loading.template);
        await FormEvents.updateQuantityItem($itemKey, quantity);
        await constructorUpsell();
        $formQuantity.empty().text(quantity);
        await CartDrawerAPI.changeAtcButtonText();
    } catch (error) {
        console.error(error);
    }
});

$(document).on('click', '.minus-btn, .plus-btn', async function (e) {
    const $item = $(this).closest('.cart-item');
    const itemKey = $item.data('key');
    const $quantityElement = $item.find('.quantity-input');
    let quantity = parseInt($quantityElement.val(), 10);
    if ($(this).hasClass('minus-btn')) {
        if (quantity <= 1) {
            quantity = 0;
        } else {
            quantity -= 1;
        }
    } else if ($(this).hasClass('plus-btn')) {
        quantity += 1;
    }

    try {
        await FormEvents.updateQuantityItem(itemKey, quantity);
        await constructorUpsell();
        await CartDrawerAPI.changeAtcButtonText();
    } catch (error) {
        console.error(error);
    }
});

async function constructorUpsell() {
  const cartItemsSection = await $.ajax({
    url: `/cart?section_id=upsell-items`,
  });
  const parser = new DOMParser();
  const cartItemsContent = parser.parseFromString(
    cartItemsSection,
    "text/html"
  );
  const $listItems = $(cartItemsContent).find("#upsell-items");
  if (!$listItems.length) {
    console.warn("No cart items found in the response.");
    return;
  }
  $("#upsell-items").empty().html($listItems);
}

function formToObject($form) {
  const fd = new FormData($form[0]);
  const obj = {};
  for (const [k, v] of fd.entries()) obj[k] = v;
  // mapeie para o formato esperado
  return {
    id: obj.id, // name="id" no form (variant_id)
    quantity: Number(obj.quantity || 1),
    // propriedades customizadas do Shopify usam properties[Chave] no form;
    // se estiver usando isso, prefira a Opção A (urlencoded) para simplificar.
  };
}


async function constructionFromActiveCards() {
const $container = $('.render-cart-items').empty();

  $('.product-main').each(function () {
    const $main = $(this);
    $main.find('.product-card.active').each(function () {
      const $card = $(this);
      const qty = $card.data('product-quantity') || 1;
      const title = $card.data('product-short-title') || 'Meal';

      $container.append(
        `<div class="acc-line-item">
          <span class="acc-line-item__quantity">${qty}x</span>
          <span class="acc-line-item__title">${title}</span>
         </div>`
      );
    });
  });
}